import React from 'react';
import { useTranslation } from '../../../../context/LanguageContext';
import CheckboxField from '../../../form/CheckboxField';
import InputField from '../../../form/InputField';

const UsersTab = ({ settings, handleChange }) => {
    const { t, isRTL } = useTranslation();

    return (
        <div className="space-y-6">
            <div className="bg-white rounded-lg p-6 shadow-sm">
                <h3 className={`text-lg font-semibold text-gray-800 mb-6 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('admin.userConfig')}
                </h3>
                <div className="grid grid-cols-1 gap-6">
                    <div className="space-y-4">
                        <CheckboxField
                            label={t('admin.allowUserRegistration')}
                            checked={settings.users?.allow_registration || false}
                            onChange={(e) => handleChange('users', 'allow_registration', e.target.checked)}
                        />
                        <CheckboxField
                            label={t('admin.requireEmailVerification')}
                            checked={settings.users?.require_email_verification || false}
                            onChange={(e) => handleChange('users', 'require_email_verification', e.target.checked)}
                        />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <InputField
                            label={t('admin.defaultRole')}
                            value={settings.users?.default_role || 'user'}
                            onChange={(e) => handleChange('users', 'default_role', e.target.value)}
                        />
                        <InputField
                            label={t('admin.sessionTimeout')}
                            value={settings.users?.session_timeout || 120}
                            type="number"
                            onChange={(e) => handleChange('users', 'session_timeout', parseInt(e.target.value))}
                            helperText={t('admin.sessionTimeoutHelp')}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UsersTab;
